export default __webpack_public_path__ + "static/media/footerLogo.00bf4aed.png";